<template>
  <div class="container-list">
    <div class="flex">
      <unitList
        v-show="!($store.state.user.userInfo.natureId == 2)"
        @select="getUnit"
        @getFirst="getOne"
      ></unitList>
      <div class="flex1">
        <div class="common-page common-head"></div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar">
            <div
              v-hasPermi="['score:maintenance:query']"
              class="btn"
              @click="showDia = true"
            >
              <i class="icon-tr-search"></i>查询
            </div>
            <div class="btn ml10" @click="resetSearch">重置</div>
            <router-link
              class="btn ml20"
              v-hasPermi="['score:maintenance:insert']"
              :to="{ path: '/company/detailsOfAssess', query: { id: cpNum } }"
            >
              <i class="icon-tr-newly-added"></i>新增
            </router-link>
          </div>
          <div class="common-page common-list">
            <el-table :data="list">
              <!-- <el-table-column prop="sc_xiaofanganquan" label="消防安全管理权重得分" align="center"></el-table-column> -->
              <el-table-column
                prop="project_name"
                label="报告名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="person"
                label="执行人"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <router-link
                    v-hasPermi="['score:maintenance:update']"
                    :to="{
                      path: '/company/detailsOfAssess',
                      query: { id: scope.row.uuid, type: 1 },
                    }"
                  >
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <router-link
                    v-hasPermi="['score:maintenance:details']"
                    :to="{
                      path: '/company/assessList',
                      query: { id: scope.row.uuid },
                    }"
                  >
                    <el-button size="mini" type="primary">详情</el-button>
                  </router-link>
                  <el-popconfirm
                    title="确定删除此记录吗？"
                    class="cursor"
                    @confirm="changeStatus(scope.row.uuid, 0)"
                    @onConfirm="changeStatus(scope.row.uuid, 0)"
                    v-hasPermi="['score:maintenance:delete']"
                  >
                    <a slot="reference" class="red">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="count"
          ></el-pagination>
        </div>
        <el-dialog
          title="查询"
          :visible.sync="showDia"
          :close-on-click-modal="false"
        >
          <fm-generate-form
            :data="searchForm"
            :remote="remoteFuncs"
            :value="editData"
            ref="searchForm"
          ></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small"
              >确定</el-button
            >
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      showDia: false,
      searchForm: this.$getForm("pingguProSearch"),
      remoteFuncs: {},
      params: {
        company_num: "",
        type: 1,
        page: 1,
        starttime: "",
        endtime: "",
      },
      list: [],
      count: 0,
      editData: {},
    };
  },
  created() {

  },
  mounted() {
    // this.getList()
  },
  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.getList();
    },
    $route: {
      handler() {
        if (this.list) {
          this.getList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getList() {
      this.$post("/score/maintenanceAssesslist", this.params).then((res) => {
        this.list = res.data.list;
        this.count = res.count;
      });
    },
    changeStatus(uuid) {
      // console.log(uuid);
      this.$post("/score/maintenanceAssessDelete", { key: uuid })
        .then((res) => {
          // console.log(res);
          // this.$message.success("删除成功");
          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
          this.getList();
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
      // console.log(this.cpNum + "111111111111111111");

    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
      this.showDia = false;
      if (this.$refs.searchForm) {
        this.$refs.searchForm.reset();

        this.params = {
          ...this.params,
          page: 1,
          limit: 10,
          ...this.$refs.searchForm.models,
        };
        this.getList();
      }
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          // console.log(this.params);
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
